import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { LoadingTable } from './components/LoadingTable/LoadingTable';
import { useAccountContext } from '../../context/useAccountContext';

export const AccountPreferencesLoading = () => {
  const { isWorkflow } = useAccountContext();

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt="24">
        <Shimmer width="215px" height="30px" />
        <Shimmer width="140px" height="30px" />
      </Box>
      <LoadingTable isWorkflow={isWorkflow} />
    </>
  );
};
